import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }

import CardListItem from '@/components/CardListItem.vue';
import ConfirmModal from '@/components/Modals/ConfirmModal.vue';
import { EOffcanvasPage } from '@/components/Offcanvas/canvas.pages';
import useOffCanvas from '@/components/Offcanvas/useOffCanvas';
import useCards from '@/composables/useCards';
import usePayment from '@/composables/usePayment';
import { EPaymentType, EModal } from '@/enums';
import { ICardInfo } from '@/interfaces';
import { onMounted, ref } from 'vue';
import useModals from '@/components/Modals/useModals';
import { ConfirmModalResponse } from '@/components/Modals/modals.types';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreditCards',
  setup(__props) {

const { creditCards, getCards, removeCard, loading } = useCards()
const { currentPaymentMethod, savePaymentMethod } = usePayment()
const { navigateCanvas, canvasBackPressed } = useOffCanvas()
const { toggleModal } = useModals()

const confirmMessage = ref('')
const cardToRemove = ref<ICardInfo | null>(null)

onMounted(() => {
  loading.value = true
  getCards()
})

const handleSelectCard = (item: ICardInfo) => {
  savePaymentMethod({
    payment_type: EPaymentType.credit_card,
    card_info: item
  })
  canvasBackPressed
}
const handleRemoveCard = (item: ICardInfo) => {
  confirmMessage.value = `Deseja remover o cartão final ${item.card_last_digits}?`
  cardToRemove.value = item
  toggleModal(EModal.confirm)
}
const handleConfirmAction = (action: ConfirmModalResponse) => {
  if (action === 'confirm' && cardToRemove.value) {
    removeCard(cardToRemove.value)
  }
  cardToRemove.value = null
}
const handleAddCardPressed = () => {
  navigateCanvas(EOffcanvasPage.add_card)
}

return (_ctx: any,_cache: any) => {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_AppLoading = _resolveComponent("AppLoading")!
  const _component_AppContainer = _resolveComponent("AppContainer")!

  return (_openBlock(), _createBlock(_component_AppContainer, { id: "app-credit-cards" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _withModifiers(handleAddCardPressed, ["prevent"]),
            class: "btn btn-link text-primary",
            id: "add-card-btn"
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "fas fa-plus-circle me-1" }, null, -1),
            _createTextVNode(" Adicionar ")
          ]))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-auto" }, null, -1))
      ]),
      _createVNode(_component_AppLoading, { loading: _unref(loading) }, {
        default: _withCtx(() => [
          (_unref(creditCards).length == 0)
            ? (_openBlock(), _createBlock(_component_EmptyState, { key: 0 }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(creditCards), (item) => {
                return (_openBlock(), _createBlock(CardListItem, {
                  card: item,
                  selected: _unref(currentPaymentMethod)?.card_info?.id == item.id,
                  onOnRemove: ($event: any) => (handleRemoveCard(item)),
                  onOnSelect: ($event: any) => (handleSelectCard(item))
                }, null, 8, ["card", "selected", "onOnRemove", "onOnSelect"]))
              }), 256))
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(ConfirmModal, {
        title: "Remover cartão",
        message: confirmMessage.value,
        confirmText: "Remover",
        onOnAction: handleConfirmAction
      }, null, 8, ["message"])
    ]),
    _: 1
  }))
}
}

})